module.exports = __webpack_public_path__ + "img/payment-channels-white.ee07a841.svg";